import RegionForm from '@/views/App/Region/Form.vue';
import RegionList from '@/views/App/Region/List.vue';

const routesRegion = [
    {
        path: 'list',
        name: 'regionList',
        component: RegionList
    },
    {
        path: 'form/:id?',
        name: 'regionForm',
        component: RegionForm
    },
];

export default routesRegion;